// Modal remove
function openModalRemove(e, is_direct = true, inputElement = undefined) {
  const element = $(e)
  let elModalRemove = document.querySelector('#modal-remove-cart');
  let elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  const qty = element.attr("data-qty");

  if (is_direct) {
    inputElement = $(element.attr('data-id'))
  }
  if (inputElement) {
    elBtnRemoveCart.setAttribute("data-quantity", inputElement.val())
  }

  elBtnRemoveCart.setAttribute("data-id-input", inputElement.attr('id'))

  if (elBtnRemoveCart) {
    elModalRemove.classList.remove('wp-hidden');
    const elPreviewImg = elModalRemove.querySelector('img');
    elPreviewImg.setAttribute('src', element.data("previewImg"));
    elBtnRemoveCart.setAttribute('data-key', element.data("key"));
  }
}

function closeModalRemove() {
  let elModalRemove = document.querySelector('#modal-remove-cart');
  let elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  const quantity = elBtnRemoveCart.getAttribute('data-quantity');
  const idInput = elBtnRemoveCart.getAttribute('data-id-input');
  const elInput = document.querySelector(`#${idInput}`)
  let itemId = elBtnRemoveCart.dataset.key;
  if (quantity <= 0) {
    const old_value = elInput.getAttribute("data-old-value");
    $(elInput).val(old_value);
  }
  elModalRemove.classList.add('wp-hidden');
  elBtnRemoveCart.removeAttribute('data-key');
}

function removeCart() {
  let elModalRemove = document.querySelector('#modal-remove-cart');
  let elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  let itemId = elBtnRemoveCart.dataset.key;
  callAPIUpdateCartPageCart(0, itemId);
  elModalRemove.classList.add('wp-hidden');
}

function openPreview(e) {
  const elBtnPreview = document.querySelector('#preview-item-cart');
  const elPreview = document.querySelector('#modal-preview');
  const elImg = elPreview.querySelector('img');
  elImg.setAttribute('src', e.dataset.previewImg);
  elPreview.classList.remove('wp-hidden');
}

function closeModalPreview() {
  const elPreview = document.querySelector('#modal-preview');
  elPreview.classList.add('wp-hidden');
}

function callAPIUpdateCartPageCart(qty, itemId, elementIdToReload) {
  showUIBlock();
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: JSON.stringify({
      id: itemId,
      quantity: qty,
    }),
    dataType: 'json',
    contentType: 'application/json',
    success: async function (cart) {
      await fetchTemplateCartPageCart(cart, 'header-desktop-cart-item', 'cart_parent_form', true);
      await fetchTemplateCartPageCart(cart, 'cart-template', 'cart_line_form', false);
      closeModalOverLay();
      hideUIBlock();
    },
    error: function () {
      hideUIBlock();
    },
  });
}

function fetchTemplateCartPageCart(cart, cart_template, cart_id, is_current_element) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `/?section_id=${cart_template}`,
      success: function (data) {
        if (is_current_element) {
          const newSection = $(data).html();
          $(`#${cart_id}`)?.replaceWith(newSection);
        } else {
          const newSection = $(data).find(`#${cart_id}`).html();
          $(`#${cart_id}`)?.html(newSection);
        }

        $(`#cart_number`).html(`(${cart?.item_count}) Cart`);
        $('#cart_number_mobi').html(`${cart?.item_count}`);
        if (cart?.item_count == 0) {
          $('.wp-countdown')?.remove();
          $('#cart_number_mobi')?.html(0);
        }

        resolve();
      },
      error: function (err) {
        console.error(err);
        reject(err);
      },
    });
  });
}

function reloadCartNumber() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    contentType: 'application/json',
    success: function (cart) {
      fetchTemplateCartPageCart(cart, 'header-desktop-cart-item', 'cart_parent_form', true);
      $("#sticky_cart_item")?.html(cart?.item_count);
      $("#sticky-cart").attr("data-cart", cart?.item_count);
    },
    error: function () { },
  });
}

function closeModalOverLay () {
  $(document).ready(function () {
    var $overlayRemove = $('#modal-remove-cart');
    var $overlayPreview = $('#modal-preview');

    $overlayRemove.on('click', function (event) {
      if (event.target === $overlayRemove[0]) {
        closeModalRemove();
      }
    });

    $overlayPreview.on('click', function (event) {
      if (event.target === $overlayPreview[0]) {
        closeModalPreview();
      }
    });
});
}
